const actionTypes = {
  BOLD: 'BOLD',
  ITALIC: 'ITALIC',
  UNDERLINE: 'UNDERLINE',
  CODE_BLOCK: 'CODE_BLOCK',
  STRIKE_THROUGH: 'STRIKE_THROUGH',
  BULLET_LIST: 'BULLET_LIST',
  NUMBER_LIST: 'NUMBER_LIST',
  CHECK_LIST: 'CHECK_LIST',
  QUOTE_TEXT: 'QUOTE_TEXT',
  HEADING_ONE: 'HEADING_ONE',
  HEADING_TWO: 'HEADING_TWO',
  HEADING_THREE: 'HEADING_THREE',
  HEADING_FOUR: 'HEADING_FOUR',
  HEADING_FIVE: 'HEADING_FIVE',
  ALIGN_LEFT: 'ALIGN_LEFT',
  ALIGN_CENTER: 'ALIGN_CENTER',
  ALIGN_RIGHT: 'ALIGN_RIGHT'
};

export default actionTypes;